import { useState, useEffect } from "react";
import { useFormCtx } from "../FormContext";
import HiddenBackButton from "./HiddenBackButton";
import Button from "./Button";
import * as Const from "../_Const";
import * as Helper from "../_Helper";
import useTvType from "../hooks/useTvType";
import AutoFitText from "./AutoFitText";

const info_panel_state_examination = "Probíhá vyšetření";
const info_panel_state_wait_for_call = "Vyčkejte na zavolání";
const info_panel_state_closed = "Zavřeno";

//      ordination type
//                 "ordinationId": 10,
//                 "order": 1,
//                 "prefix": null,
//                 "part1": "1. Dávka",
//                 "part2": null,
//                 "postfix": "Pfizer",
//                 "color": null,
//                 "doorLabel": "dvere 1",
//                 "skipExamState": false,
//                 "fontSize": 39,
//                 "ordinationDirectionID": 4

// ordinationId: 135,
// fontSize: 0,
// skipExamState: false,
// ordinationOrder: 1,
// ordinationState: Const.ORDINATION_STATE_WAIT_FOR_CALL,
// calledPatient: null,
// ordinationLabel: {
//   prefix: "MUDr.",
//   part1: "Jana",
//   part2: "Nováková",
//   postfix: null,
// },

function InfoPanelOrdination({ infoPanelState, data, ordinationItem, css, cssMargin, ordinationCount = 1 }) {
  //hack na zmenu klice pro vyvolani animace call-in vicekrat za sebou
  const [animationKey, setAnimationKey] = useState(0);

  const screenType = useTvType();
  const {
    terminalSettingsState,
    navigateHome,
    isDebugMode,
    handleDebug,
    getPageData,
    selectedPageIndex,
    showBackButton,
    navigateBackButtons,
    isDebugModeBackBtnClickable,
    navigateToServicePage,
    beep,
  } = useFormCtx();

  useEffect(() => {
    //soucast hacku kdy chci vyvolat animaci call in, vzdy kdyz se zmeni lastStateChange ktera se meni v ramci callIn
    if (data?.ordinationState === Const.ORDINATION_STATE_CALL_IN) {
      if (data?.lastStateChange) {
        triggerCallInAnimation();
        console.log("infopanelordination", data?.lastStateChange, data);
      }
    }
  }, [data?.lastStateChange]);

  const showNavigationBackButton = showBackButton();

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_TV_720) {
      switch (what) {
        case "px":
          css = 20;
          break;
      }
    } else if (screenType === Const.SCREEN_TV_768) {
      switch (what) {
        case "px":
          css = 20;
          break;
      }
    } else if (screenType === Const.SCREEN_TV_1080) {
      switch (what) {
        case "px":
          css = 24;
          break;
      }
    } else if (screenType === Const.SCREEN_TV_2160) {
      switch (what) {
        case "px":
          css = 48;
          break;
      }
    }

    //console.log(what, screenType, css);

    return css;
  }

  function handleHomeClick() {
    // if (onBackClick) {
    //   onBackClick();
    // } else {
    navigateHome();
    //}
    beep();
  }

  function triggerCallInAnimation() {
    setAnimationKey((prev) => prev + 1); // Změna klíče vynutí restart animace
  }

  function renderBg() {
    let css = "";
    switch (data?.ordinationState) {
      case Const.ORDINATION_STATE_CALL_IN:
        css = "call-in";
        break;
      case Const.ORDINATION_STATE_EXAMINATION:
        css = "bg-info-panel-examination";
        break;
      case Const.ORDINATION_STATE_CLOSED:
      case Const.ORDINATION_STATE_WAIT_FOR_CALL:
      case Const.ORDINATION_STATE_RETURN_PATIENT_WAITING_LIST:
        css = "bg-info-panel-wait";
        break;
    }
    return css;
  }

  function getRigtText() {
    let part1 = "";
    let part2 = "";
    let prefix = "";
    let postfix = "";

    // normalizační funkce
    const norm = (s) => (s || "").trim().toUpperCase();

    prefix = ordinationItem?.prefix;
    part1 = ordinationItem?.part1;
    part2 = ordinationItem?.part2;
    postfix = ordinationItem?.postfix;

    const infoPanelSettingsDataTitle = {
      prefix: norm(ordinationItem?.prefix),
      part1: norm(ordinationItem?.part1),
      part2: norm(ordinationItem?.part2),
      postFix: norm(ordinationItem?.postfix),
    };

    const patientItemTitle = {
      prefix: norm(data?.ordinationLabel?.prefix),
      part1: norm(data?.ordinationLabel?.part1),
      part2: norm(data?.ordinationLabel?.part2),
      postFix: norm(data?.ordinationLabel?.postfix),
    };

    //console.log(`getRigtText Titulky: infoPanelSettingsDataTitle: ${JSON.stringify(infoPanelSettingsDataTitle)}, patientItemTitle: ${JSON.stringify(patientItemTitle)}`,);

    //kvuli rotaci titulku je treba brat v pripade ze v datech pacietna prijdou novejsi data v data?.ordinationLabel tak vzit je
    // jinak se berou z nastaveni info panelu pri startu applikace - ordinationItem
    if (JSON.stringify(infoPanelSettingsDataTitle) !== JSON.stringify(patientItemTitle)) {
      prefix = data?.ordinationLabel?.prefix;
      part1 = data?.ordinationLabel?.part1;
      part2 = data?.ordinationLabel?.part2;
      postfix = data?.ordinationLabel?.postfix;
      //  console.log("getRigtText beru titulek z dat pacienta " + prefix, part1, part2, postfix);
    }

    //console.log("getRigtText" + prefix, part1, part2, postfix);

    switch (data?.ordinationState) {
      case Const.ORDINATION_STATE_CALL_IN:
        if (!Helper.isNullOrEmpty(infoPanelState?.callInPanelMessage)) {
          prefix = "";
          part1 = infoPanelState?.callInPanelMessage;
          part2 = "";
          postfix = "";
        }

        break;
      // case Const.ORDINATION_STATE_EXAMINATION:
      // case Const.ORDINATION_STATE_RETURN_PATIENT_WAITING_LIST:
      // case Const.ORDINATION_STATE_WAIT_FOR_CALL:
      // case Const.ORDINATION_STATE_CLOSED:

      //   break;
    }
    return { part1, part2, prefix, postfix };
  }

  function getLeftText() {
    let part1 = "";
    let part2 = "";
    switch (data?.ordinationState) {
      case Const.ORDINATION_STATE_CALL_IN:
        const names = Helper.formatNamesForInfoPanel(data?.calledPatient, infoPanelState);
        part1 = names.part1;
        part2 = names.part2;
        break;
      case Const.ORDINATION_STATE_EXAMINATION:
        part1 = Helper.isNullOrEmpty(infoPanelState?.doNotEntryPanelMessage) ? info_panel_state_examination : infoPanelState?.doNotEntryPanelMessage;
        break;
      case Const.ORDINATION_STATE_RETURN_PATIENT_WAITING_LIST:
      case Const.ORDINATION_STATE_WAIT_FOR_CALL:
        part1 = Helper.isNullOrEmpty(infoPanelState?.waitForCallPanelMessage) ? info_panel_state_wait_for_call : infoPanelState?.waitForCallPanelMessage;
        break;
      case Const.ORDINATION_STATE_CLOSED:
        part1 = info_panel_state_closed;
        break;
    }
    return { part1, part2 };
  }

  function getIconSvg(path) {
    const icon = (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" className="fill-info-panel-ordination-primary w-full">
        {path}
      </svg>
    );
    return icon;
  }

  function getIcon(direction) {
    const arrowLeft = <path d="M400-240 160-480l240-240 56 58-142 142h486v80H314l142 142-56 58Z" />;
    const arrowRight = <path d="m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z" />;
    const arrowTop = <path d="M440-240v-368L296-464l-56-56 240-240 240 240-56 56-144-144v368h-80Z" />;
    const arrowDown = <path d="M480-240 240-480l56-56 144 144v-368h80v368l144-144 56 56-240 240Z" />;
    const noArrow = <path d="M240-440v-80h480v80H240Z" />;

    const isNowStateCallIn = data?.ordinationState === Const.ORDINATION_STATE_CALL_IN ? true : false;

    //console.log(direction, isNowStateCallIn);

    let icon = getIconSvg(noArrow);
    switch (direction) {
      case Const.ORDINATION_DIRECTION_NOT_SET:
        icon = getIconSvg(noArrow);
        break;
      case Const.ORDINATION_DIRECTION_LEFT_IN_CALL:
        if (isNowStateCallIn) {
          icon = getIconSvg(arrowLeft);
        }
        break;
      case Const.ORDINATION_DIRECTION_LEFT:
        icon = getIconSvg(arrowLeft);
        break;
      case Const.ORDINATION_DIRECTION_UP_IN_CALL:
        if (isNowStateCallIn) {
          icon = getIconSvg(arrowTop);
        }
        break;
      case Const.ORDINATION_DIRECTION_UP:
        icon = getIconSvg(arrowTop);
        break;
      case Const.ORDINATION_DIRECTION_RIGHT_IN_CALL:
        if (isNowStateCallIn) {
          icon = getIconSvg(arrowRight);
        }
        break;
      case Const.ORDINATION_DIRECTION_ORIGINAL_BEHAVIOUR:
      case Const.ORDINATION_DIRECTION_RIGHT:
        icon = getIconSvg(arrowRight);
        break;
      case Const.ORDINATION_DIRECTION_DOWN_IN_CALL:
        if (isNowStateCallIn) {
          icon = getIconSvg(arrowDown);
        }
        break;
      case Const.ORDINATION_DIRECTION_DOWN:
        icon = getIconSvg(arrowDown);
        break;
    }
    return icon;
  }

  // if (screenType === Const.SCREEN_UNKNOWN) {
  //   return;
  // }

  //console.log("ordination", data);

  const { part1, part2 } = getLeftText();
  const { prefix: ordinationPrefix, part1: ordinationPart1, part2: ordinationPart2, postfix: ordinationPostfix } = getRigtText();

  //   "ordinations": [
  //             {
  //                 "ordinationId": 135,
  //                 "order": 1,
  //                 "prefix": "MUDr.",
  //                 "part1": "Jana",
  //                 "part2": "Nováková",
  //                 "postfix": null,
  //                 "color": null,
  //                 "doorLabel": "Dvere 105",
  //                 "skipExamState": false,
  //                 "fontSize": 0,
  //                 "ordinationDirectionID": -1
  //             }
  //         ]
  // };

  //console.log("xxxx", ordinationItem);

  return (
    <div
      key={animationKey}
      className={`${renderBg()} w-full ${css}  bg-accent text-white grid grid-cols-[1fr_auto_1fr] items-center border-2 tvFullHD:border-2 tv4K:border-4 border-info-panel-primary`}
    >
      {/* Sloupec 1: Levý text */}
      <div className={`${cssMargin} h-full overflow-hidden bg-accenta`}>
        <AutoFitText
          px={getCssFor("px")}
          part1={part1}
          part2={part2}
          part2Css="opacity-80"
          className="font-bold"
          justify="justify-start"
          part1Css="text-info-panel-ordination-primary"
          part2Css="text-info-panel-ordination-primary"
          gapX={"gap-x-[1em] tvFullHD:gap-x-[1.6em] tv4K:gap-x-[3.2em]"}
        />
      </div>

      {/* Sloupec 2: Fixní ikona uprostřed */}
      <div className="flex justify-center items-center px-0">
        <div className={`${ordinationCount >= 8 ? "size-10 tvFullHD:size-16 tv4K:size-36" : "size-20 tvFullHD:size-24 tv4K:size-52"} bg-accenta`}>
          {getIcon(ordinationItem?.ordinationDirectionID)}
        </div>
      </div>

      {/* Sloupec 3: Pravý text */}
      <div className={`${cssMargin} h-full overflow-hidden bg-accenta`}>
        <AutoFitText
          px={getCssFor("px")}
          prefix={ordinationPrefix}
          part1={ordinationPart1}
          part2={ordinationPart2}
          postfix={ordinationPostfix}
          className="font-bold"
          justify="justify-start"
          prefixCss="text-info-panel-ordination-primary"
          part1Css="text-info-panel-ordination-primary"
          part2Css="text-info-panel-ordination-primary"
          postfixCss="text-info-panel-ordination-primary"
          gapX={"gap-x-[1em] tvFullHD:gap-x-[1.6em] tv4K:gap-x-[3.2em]"}
        />
      </div>
    </div>
  );
}

export default InfoPanelOrdination;
